import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { TRANSACTION_EXCHANGE_CONFIG_LIST } from 'src/constants/queryKeys';

export const networkGetTransactionExchangeConfigInfo = async (id) => {
  const res = await axiosInstance.post(`TransactionExchangeConfig/Info/${id}`);
  return res;
};

export const networkGetTransactionExchangeConfigList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`TransactionExchangeConfig/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchTransactionExchangeConfigList(payload, pageIndex, pageSize) {
  return useQuery({
    queryKey: [TRANSACTION_EXCHANGE_CONFIG_LIST, payload, pageIndex],
    queryFn: () => {
      return networkGetTransactionExchangeConfigList(payload, pageIndex, pageSize);
    },
  });
}

export const networkCreateTransactionExchangeConfig = async (data) => {
  const res = await axiosInstance.post('TransactionExchangeConfig/Insert', data);
  return res;
};

export const networkUpdateTransactionExchangeConfig = async (id, data) => {
  const res = await axiosInstance.post(`TransactionExchangeConfig/Update/${id}`, data);
  return res;
};

export const networkRemoveTransactionExchangeConfig = async (TransactionExchangeConfigId) => {
  const res = await axiosInstance.post(`TransactionExchangeConfig/Remove/${TransactionExchangeConfigId}`);
  return res;
};
